import { connect } from 'react-redux';
import { logoutActionCreator } from '../../login/data/actions';
import { initBackofficeRequestsActionCreator, toggleConfirmitProjectActionCreator } from '../data/actions';
import { getBackofficeTablesDataSelector } from '../data/selectors';
import BackofficeDefault from './BackofficeDefault';
const mapStateToProps = state => ({
    tablesData: getBackofficeTablesDataSelector(state),
});

const mapDispatchToProps = {
    initBackofficeTablesData: initBackofficeRequestsActionCreator,
    initConfirmItToggle: toggleConfirmitProjectActionCreator,
    logout: logoutActionCreator,
};

export default connect(mapStateToProps, mapDispatchToProps)(BackofficeDefault);
